import api from "./client";
import { CheckoutPayload, CheckoutResponse } from "../types";

export const createCheckout = (data: CheckoutPayload) => {
  return api.post<CheckoutResponse>("/payments/create-checkout", data);
};
